<template>
  <div>
    
    <flip-countdown :deadline="time" ></flip-countdown>
    
    
  </div>
</template>

<script>
  import FlipCountdown from 'vue2-flip-countdown'

  export default {
      components: { FlipCountdown },
     
      data: () => ({
      time:' 2020-06-18 10:18:00',
      })
  }
</script>
<style>


</style>